module.exports = __webpack_public_path__ + "static/media/baidu.77304d0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/baidu.png
// module id = 73
// module chunks = 0